import { RESET_PVS_REGISTRATION } from "../../redux/types/pvs"
import { LOGOUT_REQUEST } from "../../redux/types/auth"
import {
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  FETCH_USER_DETAILS_REQUEST,
  FETCH_USER_DETAILS_SUCCESS,
  FETCH_USER_DETAILS_FAILURE,
  FETCH_AWARD_USER_REQUEST,
  FETCH_AWARD_USER_SUCCESS,
  FETCH_AWARD_USER_FAILURE,
  FETCH_LUCKY_DRAW_USER_REQUEST,
  FETCH_LUCKY_DRAW_USER_SUCCESS,
  FETCH_LUCKY_DRAW_USER_FAILURE,
  RESET_USER_STATE,
  GET_PRODUCT_LIST_SUCCESS,
  UPDATE_PVS_DATA_SUCCESS,
  PAYMENT_SUCCESS,
} from "../types/user"

const initialState = {
  loading: false,
  users: [],
  user: {},
  error: null,
  success: false,
  message: "",
  products: null,
  stepFormData: null,
  pvsList: [],
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_REQUEST:
    case CREATE_USER_REQUEST:
    case UPDATE_USER_REQUEST:
    case DELETE_USER_REQUEST:
    case FETCH_USER_DETAILS_REQUEST:
    case FETCH_AWARD_USER_REQUEST:
    case FETCH_LUCKY_DRAW_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      }

    case FETCH_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
        success: true,
      }

    case CREATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: [...state.categories, action.payload],
        success: true,
        message: "User created successfully",
      }

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        message: "User updated successfully",
      }

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        message: "User deleted successfully",
      }

    case FETCH_USER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
        success: true,
        message: "User created successfully",
      }
    case FETCH_LUCKY_DRAW_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        luckyDrawUser: action.payload,
        success: true,
        message: "Get Lucky Draw User successfully",
      }
    case FETCH_AWARD_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        awardUser: action.payload,
        success: true,
        message: "Get Awards User successfully",
      }
    case FETCH_USER_FAILURE:
    case CREATE_USER_FAILURE:
    case UPDATE_USER_FAILURE:
    case DELETE_USER_FAILURE:
    case FETCH_USER_DETAILS_FAILURE:
    case FETCH_AWARD_USER_FAILURE:
    case FETCH_LUCKY_DRAW_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      }

    case GET_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        products: action.payload.products,
      }

    case RESET_USER_STATE:
      return {
        ...initialState,
      }

    case UPDATE_PVS_DATA_SUCCESS:
      return {
        ...state,
        stepFormData: action.payload.data,
      }
    case PAYMENT_SUCCESS:
      return {
        ...state,
        pvsList: [...state.pvsList, action.payload.data],
      }
    case RESET_PVS_REGISTRATION:
      return {
        ...state,
        products: null,
      }
    // case LOGOUT_REQUEST:
    //   return {
    //     ...state,
    //     stepFormData: null,
    //     pvsList: [],
    //   }

    default:
      return state
  }
}

export default userReducer
